<template>
  <div class="student-info">
    <div class="content">
      <div class="style">
        <el-row :gutter="20" class="class-info">
          <el-col :span="12">
            <div>学校名称：{{ schoolName }}</div>
          </el-col>
          <el-col :span="12" class="right-item nickname">
            <span>{{ teacherName }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div>上机人数：{{ onBoardNum }}</div>
          </el-col>
          <el-col :span="12" class="right-item logout">
            <i class="iconfont icon-exit"></i>
            <span @click="logout">退机</span>
          </el-col>
        </el-row>
      </div>
      <div class="style list">
        <div class="data-time">
          <el-date-picker
            :value="listDate"
            type="date"
            :clearable="false"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            @input="changeSearchDate"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <el-table
          :data="studentList"
        >
          <el-table-column
            fixed
            prop="name"
            label="上机学生"
            align="center"
            width="250">
          </el-table-column>
          <el-table-column
            fixed
            prop="description"
            label="学习进度">
            <!-- <template slot="header">
              <div>学习进度</div>
              <el-date-picker
                :value="listDate"
                type="date"
                format="yyyy/MM/dd"
                value-format="yyyy/MM/dd"
                :default-value="listDate"
                @input="changeSearchDate"
                placeholder="选择日期">
              </el-date-picker>
            </template> -->
            <template slot-scope="scope">
              {{scope.row.time}} {{ scope.row.description }}
            </template>
          </el-table-column>
          <el-table-column
            fixed
            prop="operate"
            label="上级学生"
            align="right"
            width="350">
            <template slot="header">
              <el-input
                v-model="student"
                size="small"
                prefix-icon="el-icon-search"
                @keyup.enter.native="(e) => fetchStudents(true)"
                placeholder="搜索学生"/>
            </template>
            <template slot-scope="scope">
              <div class="btn-wrap">
                <div @click="showStatistic(scope.row)" class="btn btn-blue-square">
                  数据总览
                </div>
                <div class="btn btn-orange-square"  @click="showDetail(scope.row)">
                  查看详情
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <teach-dialog :title="logName" ref="detail" width="760px" @cancel="cancelLog">
      <div class="detail">
        <el-row :gutter="10">
          <el-col :span="8" class="date-wrap">
            <span>日期：{{ year }}/{{ month }}/{{ day }}</span>
            <span class="change-time" @click="openDatepicker">更换日期</span>
            <div class="picker" v-if="showDatePicker">
              <van-calendar
                unable
                :point="days"
                @change="changeDate"
                @close="close"
                @confirm="confirm"
                :date="dateForCalendar"
              ></van-calendar>
            </div>
          </el-col>
          <el-col :span="8">
            {{ logInfo.learn_time }}
          </el-col>
          <el-col :span="8">
            学习课程：{{ courses }}
          </el-col>
        </el-row>
        <log-timeline :list="logInfo.data" />
      </div>
    </teach-dialog>
    <teach-dialog title="数据总览" ref="statistic" width="760px">
      <div class="data-info">
        <div class="student">{{ currentStudent.name }}</div>
        <div class="course" v-for="course in totalData" :key="course.name">
          <div v-if="course.subject_group === 'vocabulary'">
            <p>{{ course.name }}</p>
            <div class="panel-wrap" v-if="course.data">
              <div class="panel">
                <span class="num">{{ course.data.learn_word_count }}</span>
                <span>已学单词</span>
              </div>
              <div class="panel">
                <span class="num">{{course.data.learn_examination_count}}个</span>
                <span>已做测试</span>
              </div>
              <div class="panel">
                <span class="num">{{course.data.grasp_word_count}}个</span>
                <span>已掌握单词</span>
              </div>
              <div class="panel">
                <span class="num">{{course.data.trophy_count}}个</span>
                <span>获得奖状数量</span>
              </div>
            </div>
          </div>
          <div v-else>
            <el-row>
              <el-col :span="2" class="course-label">{{ course.name }}</el-col>
              <el-col :span="7">
                <el-select
                  v-model="course.book"
                  size="mini"
                  placeholder="请选择"
                  @change="getBookDetail"
                >
                  <el-option
                    v-for="item in course.books"
                    :key="item.book_id"
                    :label="item.book_name"
                    :value="item.book_id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="14" :offset="1">
                <span class="tips">切换“课程”可查看其它课程数据</span>
              </el-col>
            </el-row>
            <div class="panel-wrap" v-if="course.currentBookInfo">
              <div class="panel">
                <span class="num">{{course.currentBookInfo.learnKnowledgeCount}}个</span>
                <span>已学知识点</span>
              </div>
              <div class="panel">
                <span class="num">{{course.currentBookInfo.wrongNoteCount}}个</span>
                <span>当前错题</span>
              </div>
              <div class="panel big-panel">
                <div>
                  已做 <span class="num">
                    {{ course.currentBookInfo.testCount }}
                  </span> 套试卷，其中满分 <span class="num">
                    {{ course.currentBookInfo.testFullMarkCount }}
                  </span> 次！
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </teach-dialog>
    <teach-dialog title="登录异常提醒" ref="warning" width="660px">
      <div class="warning-content">
        <div v-html="alterMessage" class="warning">
        </div>
        <div class="code-wrap">
          <div>客服微信</div>
          <div class="code">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/9a0396ac510f870b6267ac233034ce37.jpg" />
          </div>
          <div>
            <el-button type="warning" class="close-warning" @click="closeWarning">关闭</el-button>
          </div>
        </div>
      </div>
    </teach-dialog>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Table,
  TableColumn,
  Input,
  Select,
  Option,
  DatePicker,
} from 'element-ui';
import TeachDialog from './components/Dialog.vue';
import VanCalendar from './components/Calendar.vue';
import LogTimeline from './components/LogTimeline.vue';
import api from '@/api/graphql/teacher';
import utils from '@/services/utils';

export default {
  name: 'info',
  components: {
    TeachDialog,
    LogTimeline,
    VanCalendar,
    ElRow: Row,
    ElCol: Col,
    ElTable: Table,
    ElTableColumn: TableColumn,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
  },
  data() {
    return {
      student: '',
      studentList: [],
      date: '',
      days: [],
      showDatePicker: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
      schoolName: '',
      onBoardNum: 0,
      totalData: [],
      timer: null,
      alterMessage: '', // 弹窗内容
      currentStudent: {
        name: '',
        id: 0,
      },
      logInfo: {
        subject_name: [],
        learn_time: '',
        data: [],
      },
      listDate: utils.Date.format(new Date(), 'yyyy/MM/dd'),
    };
  },
  computed: {
    teacherName() {
      return utils.storage('account').name;
    },
    logName() {
      return `${this.currentStudent.name}学习日志`;
    },
    courses() {
      return this.logInfo.subject_name.length ? this.logInfo.subject_name.join('、') : '-';
    },
    dateForCalendar() {
      return `${this.year}-${this.month}-${this.day}`;
    },
  },
  methods: {
    fetchStudents(loading = true) {
      api.studentList({
        studentName: this.student,
        date: this.listDate,
      }, loading).then(({ studentList }) => {
        const {
          list,
          onBoardNum,
          schoolName,
          alterMessage,
        } = studentList;
        this.studentList = list;
        this.onBoardNum = onBoardNum;
        this.schoolName = schoolName;
        if (alterMessage) {
          this.alterMessage = alterMessage;
          this.$refs.warning.open();
        }
      });
    },
    showDetail(row) {
      this.currentStudent = row;

      // 添加跟外部联动日期
      /* eslint-disable */
      const times = this.listDate.split('/');
      this.year = times[0];
      this.month = times[1] * 1;
      this.day = times[2] * 1;

      this.getDays(this.year, this.month);
      this.$refs.detail.open();
    },
    showStatistic(row) {
      this.currentStudent = row;
      this.getStudentStatistic();
    },
    getStudentStatistic() {
      utils.post('/api/home/user/report/get/reportOverall', {
        student_id: this.currentStudent.id,
        is_u_duty_r: 1,
      }).then((data) => {
        if (data.length > 0) {
          this.$refs.statistic.open();
          const newData = data.map((course) => {
            if (course.subject_group === 'vocabulary') {
              return course;
            }
            return {
              ...course,
              book: course.books[0].book_id,
            };
          });
          this.totalData = newData;
          // api 获取没门课程的数据
          this.totalData.forEach((course) => {
            if (course.subject_group !== 'vocabulary') {
              this.getBookDetail(course.book, false);
            }
          });
        } else {
          utils.alert('暂无数据');
        }
      });
    },
    getDays(year, month) {
      utils.post('/api/home/user/report/get/calendarDisplay', {
        student_id: this.currentStudent.id,
        year,
        month: (month < 10 ? `0${month}` : month),
        is_u_duty_r: 1,
      }).then((data) => {
        this.days = data;
        this.fetchLog();
      });
    },
    fetchLog() {
      const month = (this.month < 10 ? `0${this.month}` : this.month);
      const day = (this.day < 10 ? `0${this.day}` : this.day);
      utils.post('/api/home/user/report/get/studentLog', {
        student_id: this.currentStudent.id,
        date: `${this.year}/${month}/${day}`,
        now_page: 1,
        per_page: 1000,
        is_u_duty_r: 1,
      }).then((data) => {
        this.logInfo = data;
      });
    },
    close() {
      this.showDatePicker = false;
    },
    cancelLog() {
      this.year = new Date().getFullYear();
      this.month = new Date().getMonth() + 1;
      this.day = new Date().getDate();
      this.logInfo = {
        subject_name: [],
        learn_time: '',
        data: [],
      };
      this.close();
    },
    changeDate(e) {
      const { year, month } = e;
      if (e.day === '') {
        this.getDays(year, month);
      }
    },
    confirm(e) {
      this.year = e.year;
      this.month = e.month;
      this.day = e.day;
      this.showDatePicker = false;
      this.page = 1;
      this.fetchLog();
    },
    openDatepicker() {
      this.showDatePicker = true;
    },
    refresh() {
      this.timer = setInterval(() => {
        this.fetchStudents(false);
      }, 60 * 1000);
    },
    closeWarning() {
      this.alterMessage = '';
      this.$refs.warning.close();
    },
    logout() {
      clearInterval(this.timer);
      this.timer = null;
      utils.logout();
    },
    getBookDetail(bookId, loading = true) {
      utils.post('/api/home/user/report/get/reportOverallOneBook', {
        student_id: this.currentStudent.id,
        book_id: bookId,
        is_u_duty_r: 1,
      }, loading).then((data) => {
        this.totalData = this.totalData.map((item) => {
          if (item.book === bookId) {
            return {
              ...item,
              currentBookInfo: {
                learnKnowledgeCount: data.learn_knowledge_count,
                testCount: data.test_count,
                testFullMarkCount: data.test_full_mark_count,
                wrongNoteCount: data.wrong_note_count,
              },
            };
          }
          return {
            ...item,
          };
        });
      });
    },
    changeSearchDate(e) {
      if (e) {
        this.listDate = e;
      } else {
        this.listDate = utils.Date.format(new Date(), 'yyyy/MM/dd');
      }
      this.fetchStudents();
    },
  },
  created() {
    this.fetchStudents();
    this.refresh();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';
html {
  overflow: auto;
}
.student-info {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  background-size: cover;
  background: url(https://vanthink.oss-cn-qingdao.aliyuncs.com/17227050e20c32d3406f24454036de99.png) no-repeat 50%/cover;
  font-size: 16px;
  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin: 0 auto;
    padding-top: 60px;
    width: 90%;
    height: calc(100% - 60px);
    .class-info {
      margin-bottom: 15px;
    }
    .style {
      margin-bottom:20px;
      padding: 20px 30px;
      width: calc(100% - 60px);
      border-radius: 20px;
      background: #fff;
      .right-item {
        text-align: right;
      }
      .nickname {
        color: $primary;
      }
      .logout {
        color: red;
        cursor: pointer;
      }
    }
    .list {
      position: relative;
      flex: 1;
      overflow: auto;
      .el-table th {
        padding: 0;
      }
      .data-time {
        position: absolute;
        top: 20px;
        left: 360px;
        z-index: 200;
      }
    }
  }
}
.detail {
  min-height: 400px;
  .change-time {
    margin-left: 10px;
    color: $primary;
    cursor: pointer;
  }
  .date-wrap {
    position: relative;
    .picker {
      position: absolute;
      top: 20px;
      left: 0;
      z-index: 200;
      border: 1px solid #f1f1f1;
      border-radius: 4px;
    }
  }
}
.data-info {
  padding: 5px 15px;
  .student {
    font-size: 28px;
  }
  .panel-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    .panel {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 160px;
      height: 70px;
      border-radius: 18px;
      box-shadow: 0 0 10px rgba(0,56,216,.3);
      .num{
        font-size: 20px;
        color: #5256e6;
      }
      >span{
        &:first-child {
          padding-bottom: 5%;
        }
      }
    }
    .big-panel {
      width: 320px;
    }
  }
  .course-label {
    line-height: 28px;
  }
  .tips {
    line-height: 28px;
    color: #898989;
  }
  .course {
    margin-bottom: 20px;
  }
}
.warning-content {
  .warning {
    font-size: 18px;
  }
  .code-wrap {
    margin-top:10px;
    text-align: center;
    .code {
      display: inline-block;
      width: 100px;
      height: 100px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .close-warning {
      width: 120px;
    }
  }
}
.btn-wrap {
  display: flex;
  justify-content: right;
  align-items: center;
  .btn {
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    cursor: pointer;
  }
  .btn-blue-square, .btn-orange-square{
    width: 90px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
  }
  .btn-orange-square {
    margin-left: 10px;
    background: url(https://vanthink.oss-cn-qingdao.aliyuncs.com/a4a61c60a96ac2bd9b8381a464d3c6dd.png) no-repeat 50%/100% 100%;
    text-shadow: 1px 1px #e59600, -1px -1px #e59600, 1px -1px #e59600, -1px 1px #e59600;
  }
  .btn-blue-square {
    background: url(https://vanthink.oss-cn-qingdao.aliyuncs.com/ce3a4d73d8e5f3a0684df3fce2dbe6c0.png) no-repeat 50%/100% 100%;
    text-shadow: 1px 1px #5a95f6, -1px -1px #5a95f6, 1px -1px #5a95f6, -1px 1px #5a95f6;
  }

}

</style>
